import {NgModule} from '@angular/core';

import {MuntinsLayoutService} from './muntins-layout.service';
import { MuntinsService } from './muntins.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        MuntinsLayoutService,
        MuntinsService,
    ],
})
export class MuntinsModule { }
